module.exports = __webpack_public_path__ + "static/media/4.question.92fcd56f.mp4";